import { useState, type CSSProperties } from "react";
import { getTeamLogoUrl, getTeamVisual } from "../lib/teamVisuals";

export function TeamIdentity({
  abbr,
  name,
  score,
  side,
}: {
  abbr: string;
  name: string;
  score: number;
  side: "away" | "home";
}) {
  const visual = getTeamVisual(abbr);
  const [logoFailed, setLogoFailed] = useState(false);
  const logoUrl = getTeamLogoUrl(abbr);

  return (
    <div
      className={`team-identity ${side}`}
      style={
        {
          "--team-primary": visual.primary,
          "--team-accent": visual.accent,
        } as CSSProperties
      }
    >
      <div className="team-logo-shell" aria-hidden="true">
        {!logoFailed && logoUrl ? (
          <img
            className="team-logo"
            src={logoUrl}
            alt=""
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <span className="team-logo-fallback">{abbr}</span>
        )}
      </div>

      <div className="team-copy">
        <div className="team-abbr">{abbr}</div>
        <div className="team-full-name">{name}</div>
      </div>

      <div className="detail-score">{score}</div>
    </div>
  );
}

